module.exports = __webpack_public_path__ + "img/积分兑换.fd4fbd52.png";